import { useEffect, useState } from 'react'
import { jsonrpc } from '~/shared/api/jsonrpc'
import { CALENDAR, PeriodFigures } from '~/team_tools/dashboard/statistic/figures'
import { Box, Header } from '~/shared/ui'
import { useWindowParams } from '~/team_tools/dashboard/statistic/period'
import { useZone } from '~/team_tools/components/timezone'

export const AccountsBetaUserActiveCount = () => {
    const [accounts, setAccounts] = useState<Record<string, number>>({})

    const [zone] = useZone()
    const window = useWindowParams()
    const periods = ['total', 'today', 'week', 'month', '24_hours', '7_days', '30_days'].concat(
        window.custom ? ['custom'] : []
    )

    useEffect(() => {
        let live = true
        jsonrpc('statistic.accounts.active_beta_users_count', { periods, tz: zone, ...window.figure }).then(
            (resp) => live && setAccounts(resp.result || {})
        )
        return () => {
            live = false
        }
    }, [zone, window.key])

    return (
        <Box className='w-full text-center'>
            <Header>Active beta users</Header>
            <small className='text-white/50'>
                Active means that the user has tried to join the game BR1 Infinite in the selected time period.
            </small>
            <PeriodFigures
                periods={CALENDAR}
                loading={accounts.month === undefined}
                value={(period) => accounts[period]}
            />
        </Box>
    )
}
